var configuratorInit;

(function ($) {

	const selectors = {
		wrap: '[data-configurator]',
		rangeSlider: '[data-configurator-range]',
		summaryImage: '[data-summary-image]',
		summaryLayersContainer: '[data-summary-layers-container]'
	}

	configuratorInit = function () {
		$(selectors.wrap).each((i, el) => {
			new Configurator(el);
		});
	}

	class Configurator {

		constructor(element) {
			this.$wrap = $(element);

			// Add tracking for form values and comments
			this.formValues = {};
			this.formComments = {};
			this.stepNames = {};

			// Add tracking for image layers
			this.colorQuestion = null;
			this.selectedColor = null;
			this.layerElements = {};

			this.init();
			this.bind();

			this.loadStepNames();
			this.initStepGroups();
			this.initSummarySection();
			this.initNoUiSlider();
			this.initImageLayers();
		}

		init() {
			this.$sliders = $(selectors.rangeSlider, this.$wrap);
			this.$summaryImage = $(selectors.summaryImage, this.$wrap);
			this.$summaryLayersContainer = $(selectors.summaryLayersContainer, this.$wrap);
		}

		bind() {
		}

		loadStepNames() {
			// Load all step names from hidden inputs
			$('input[data-step-name]', this.$wrap).each((i, el) => {
				const $input = $(el);
				const stepIdx = $input.data('step-idx');
				const stepName = $input.data('step-name');
				const groupWithPrev = $input.data('group-with-prev');
				this.stepNames[stepIdx] = {
					name: stepName,
					groupWithPrev: groupWithPrev
				};
			});
		}

		initSummarySection() {
			// Find summary containers
			this.$optionsSummary = $('[data-configurator-options]', this.$wrap);
			this.$commentsSummary = $('[data-configurator-comments]', this.$wrap);

			if (!this.$optionsSummary.length && !this.$commentsSummary.length) return;

			// Setup event listeners for all form elements
			this.setupFormTracking();
		}

		setupFormTracking() {
			// Track range sliders which already have their own setup
			this.$sliders.each((i, slider) => {
				const $slider = $(slider);
				this.setupRangeTracking($slider);
			});

			// Track checkboxes using data-field-type attribute
			$('input[data-field-type="checkbox"]', this.$wrap).each((i, el) => {
				this.setupCheckboxTracking($(el));
			});

			// Track comments (textareas) using data-field-type attribute
			$('[data-field-type="comment"]', this.$wrap).each((i, el) => {
				this.setupCommentTracking($(el));
			});

			// Handle multi-choice fields (radio buttons with photos)
			this.setupMultiChoiceTracking();
		}

		setupRangeTracking($slider) {
			const sliderId = $slider.attr('id');
			const inputField = document.getElementById(`${sliderId}-input`);
			const fieldLabel = $slider.data('field-label');

			$(inputField).on('change', () => {
				this.updateFormValue(inputField.name, inputField.value, fieldLabel, 'range', { suffix: $slider.data('suffix') });
			});
		}

		setupCheckboxTracking($checkbox) {
			const name = $checkbox.attr('name');
			const fieldLabel = $checkbox.data('field-label') || '';

			$checkbox.on('change', () => {
				const isChecked = $checkbox.prop('checked');

				if (isChecked) {
					this.updateFormValue(name, true, fieldLabel, 'checkbox');
				} else {
					this.removeFormValue(name);
				}
			});
		}

		setupCommentTracking($textarea) {
			const name = $textarea.attr('name');

			$textarea.on('change input', () => {
				const value = $textarea.val();

				if (value) {
					this.updateFormComment(name, value);
				} else {
					this.removeFormComment(name);
				}
			});
		}

		updateFormValue(name, value, label, type, data) {
			// Extract step index from field name
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (!this.formValues[stepIdx]) {
				this.formValues[stepIdx] = {};
			}

			this.formValues[stepIdx][name] = {
				value: value,
				label: label || name,
				type: type,
				data: data
			};

			this.renderSummary();

			// Update the summary image layers when form values change
			if (this.$summaryLayersContainer.length > 0) {
				this.updateSummaryLayers();
			}
		}

		// Override the existing removeFormValue method to also update layers
		removeFormValue(name) {
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (this.formValues[stepIdx] && this.formValues[stepIdx][name]) {
				delete this.formValues[stepIdx][name];
				this.renderSummary();

				// Update the summary image layers when form values change
				if (this.$summaryLayersContainer.length > 0) {
					this.updateSummaryLayers();
				}
			}
		}

		updateFormComment(name, value) {
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (!this.formComments[stepIdx]) {
				this.formComments[stepIdx] = {};
			}

			this.formComments[stepIdx][name] = value;
			this.renderSummary();
		}

		removeFormComment(name) {
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (this.formComments[stepIdx] && this.formComments[stepIdx][name]) {
				delete this.formComments[stepIdx][name];
				this.renderSummary();
			}
		}

		renderSummary() {
			this.renderOptionsSummary();
			this.renderCommentsSummary();
			this.updateHiddenConfigField();

			console.log(this);
		}

		renderCommentsSummary() {
			if (!this.$commentsSummary.length) return;

			let html = '';
			let hasComments = false;

			// Loop through each step with comments individually (no grouping)
			for (const stepIdx in this.formComments) {
				const commentsData = this.formComments[stepIdx];
				if (Object.keys(commentsData).length === 0) continue;

				// Get step name from our cached step names
				const stepName = this.stepNames[stepIdx] ? this.stepNames[stepIdx].name : `Step ${stepIdx}`;

				// Add each comment
				for (const fieldName in commentsData) {
					const comment = commentsData[fieldName];
					html += `<p><strong>${stepName}:</strong> ${comment}</p>`;
					hasComments = true;
				}
			}

			// Find the comments wrap container
			const $commentsWrap = $('[data-configurator-comments-wrap]', this.$wrap);

			if (hasComments) {
				this.$commentsSummary.html(html);
				$commentsWrap.show();
			} else {
				this.$commentsSummary.empty();
				$commentsWrap.hide();
			}
		}

		updateHiddenConfigField() {
			// Find the hidden config fields inside the summary contact section
			const $topConfigField = $('[data-summary-contact] input[name="extra_info_top"]', this.$wrap);
			const $configField = $('[data-summary-contact] input[name="extra_info"]', this.$wrap);
			const title = $('[data-configurator-title]').text();

			if (!$configField.length) return;

			// Update top field with styled header and image
			if ($topConfigField.length) {
				let topHtml = '';

				// Add styled title header
				topHtml += '<div class="x_2141359883title" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; display: table; text-align: center"><span style="display: table-cell; vertical-align: middle">' + title.toUpperCase() + '</span></div>';

				// Add image section
				const $baseImage = $('.c-configurator__summary-base-image img', this.$wrap);
				if ($baseImage.length) {
					const imgSrc = $baseImage.attr('src');
					if (imgSrc) {
						topHtml += '<div class="x_2141359883image" style="text-align: center; padding: 10px">';
						topHtml += `<img src="${imgSrc}" alt="Product image" width="450" title="Product image" style="width: 450px">`;
						topHtml += '</div>';
					}
				}

				$topConfigField.val(topHtml);
			}

			// Update bottom field with styled specification
			let bottomHtml = '';

			// Check if we have any form values to display
			let hasOptions = false;
			for (const stepIdx in this.formValues) {
				const stepData = this.formValues[stepIdx];
				if (stepData && Object.keys(stepData).length > 0) {
					hasOptions = true;
					break;
				}
			}

			if (hasOptions) {
				// Add specification header
				bottomHtml += '<div class="x_2141359883specification" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; text-align: left; padding-left: 20px; display: table"><span style="display: table-cell; vertical-align: middle">SPECIFICATION</span></div>';
				bottomHtml += '<div class="x_2141359883specification_value" style="padding: 25px; line-height: 1.5em; font-size: 10pt">';
				bottomHtml += '<p class="x_2141359883conf_summary_list" id="x_2141359883conf_summary_list"></p>';

				// Add specification items for each selected option
				for (const group of this.stepGroups) {
					// Skip empty groups
					if (!this.groupHasValues(group.steps)) continue;

					// Add items from all steps in this group
					for (const stepIdx of group.steps) {
						const stepData = this.formValues[stepIdx] || {};

						// Add each option as a specification item
						for (const fieldName in stepData) {
							const fieldData = stepData[fieldName];
							let optionName = '';
							let optionValue = '';

							if (fieldData.type === 'checkbox' && fieldData.value === true) {
								// Checkbox format - check if it has a selected option (for multi-choice fields)
								if (fieldData.data && fieldData.data.selectedOption) {
									optionName = fieldData.label.toUpperCase();
									optionValue = fieldData.data.selectedOption;
								} else {
									optionName = fieldData.label.toUpperCase();
									optionValue = 'YES';
								}
							} else if (fieldData.type === 'range') {
								// Range format
								const suffix = fieldData.data && fieldData.data.suffix ? fieldData.data.suffix : '';
								optionName = fieldData.label.toUpperCase();
								optionValue = `${fieldData.value} ${suffix}`.trim();
							} else {
								// Generic format for other field types
								optionName = fieldData.label.toUpperCase();
								optionValue = fieldData.value;
							}

							if (optionName && optionValue) {
								bottomHtml += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
								bottomHtml += `<div class="x_2141359883conf_summary_name">${optionName}</div>`;
								bottomHtml += `<div class="x_2141359883conf_summary_price" style="color: rgb(113, 184, 255)">${optionValue}</div>`;
								bottomHtml += '</div>';
							}
						}
					}
				}

				// Add comments if they exist
				const $commentsWrap = $('[data-configurator-comments-wrap]', this.$wrap);
				if (this.$commentsSummary.html()) {
					for (const stepIdx in this.formComments) {
						const commentsData = this.formComments[stepIdx];
						if (Object.keys(commentsData).length === 0) continue;

						// Get step name from our cached step names
						const stepName = this.stepNames[stepIdx] ? this.stepNames[stepIdx].name : `Step ${stepIdx}`;

						// Add each comment
						for (const fieldName in commentsData) {
							const comment = commentsData[fieldName];
							bottomHtml += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
							bottomHtml += `<div class="x_2141359883conf_summary_name">${stepName.toUpperCase()} COMMENT</div>`;
							bottomHtml += `<div class="x_2141359883conf_summary_price" style="color: rgb(113, 184, 255)">${comment}</div>`;
							bottomHtml += '</div>';
						}
					}
				}

				bottomHtml += '</div>';
			}

			// Update the bottom hidden field value
			$configField.val(bottomHtml);
		}

		initStepGroups() {
			// Create an array of objects with step groups and their titles
			this.stepGroups = [];
			let currentGroup = [];

			// Get all step indices from stepNames
			const stepIndices = Object.keys(this.stepNames).map(Number).sort((a, b) => a - b);

			for (const stepIdx of stepIndices) {
				// If this step should be grouped with previous and we have a current group
				if (this.stepNames[stepIdx] && this.stepNames[stepIdx].groupWithPrev && currentGroup.length > 0) {
					// Add to the current group
					currentGroup.push(stepIdx);
				} else {
					// Start a new group if the current one is not empty
					if (currentGroup.length > 0) {
						// Add the group with its pre-generated title
						this.stepGroups.push({
							steps: currentGroup,
							title: this.generateGroupTitle(currentGroup)
						});
					}
					currentGroup = [stepIdx];
				}
			}

			// Add the last group if not empty
			if (currentGroup.length > 0) {
				this.stepGroups.push({
					steps: currentGroup,
					title: this.generateGroupTitle(currentGroup)
				});
			}
		}


		// Helper method to check if any step in the group has values
		groupHasValues(groupSteps) {
			for (const stepIdx of groupSteps) {
				const stepData = this.formValues[stepIdx];
				if (stepData && Object.keys(stepData).length > 0) {
					return true;
				}
			}
			return false;
		}



		// Helper method to generate a title for a group of steps
		generateGroupTitle(group) {
			// Get names of steps in this group
			const stepNames = group.map(stepIdx => {
				return this.stepNames[stepIdx] ? this.stepNames[stepIdx].name : `Step ${stepIdx}`;
			});

			if (stepNames.length === 1) {
				// Single step
				return stepNames[0];
			} else if (stepNames.length === 2) {
				// Two steps - format as "Step 1 & Step 2"
				return `${stepNames[0]} & ${stepNames[1]}`;
			} else {
				// More than two steps - format as "Step 1, Step 2, ... & Last Step"
				const lastStep = stepNames.pop();
				return `${stepNames.join(', ')} & ${lastStep}`;
			}
		}

		// Add a new method to set up multi-choice tracking
		setupMultiChoiceTracking() {
			// Find all multi-choice option containers
			const $multiChoiceWrap = $('.c-configurator__multi-choice-wrap', this.$wrap);

			$multiChoiceWrap.each((i, wrap) => {
				const $wrap = $(wrap);
				const $photoContainer = $('[data-multi-choice-photo]', $wrap);
				const $options = $('[data-multi-choice-option]', $wrap);
				const $checkbox = $('input[type="checkbox"]', $wrap);
				const $radioButtons = $options.find('input[type="radio"]');
				const fieldName = $checkbox.attr('name');
				const fieldLabel = $checkbox.data('field-label') || '';
				const isColorQuestion = $wrap.find('.c-configurator__multi-choice').data('is-color-question') === 1;

				// Set initial photo (first option's photo) even when no radio is selected
				this.updateMultiChoicePhotoForFirst($wrap);

				// Handle radio button changes
				$radioButtons.on('change', () => {
					// Update the photo
					this.updateMultiChoicePhoto($wrap);

					// Auto-check the checkbox when a radio option is selected
					if (!$checkbox.prop('checked')) {
						$checkbox.prop('checked', true);

						// Update the summary
						const selectedValue = $('input[type="radio"]:checked', $wrap).val() || '';
						this.updateFormValue(fieldName, true, fieldLabel, 'checkbox', {
							selectedOption: selectedValue
						});
					} else {
						// Update existing summary with new selected option
						const selectedValue = $('input[type="radio"]:checked', $wrap).val() || '';
						this.updateFormValue(fieldName, true, fieldLabel, 'checkbox', {
							selectedOption: selectedValue
						});
					}

					// If this is a color question, update the selected color and refresh all layers
					if (isColorQuestion) {
						this.updateSelectedColor();
						this.updateSummaryLayers();
					}
				});

				// Handle checkbox changes
				$checkbox.on('change', () => {
					const isChecked = $checkbox.prop('checked');

					if (isChecked) {
						// If no radio button is selected, select the first one
						const $checkedRadio = $radioButtons.filter(':checked');
						if ($checkedRadio.length === 0) {
							$radioButtons.first().prop('checked', true);
							this.updateMultiChoicePhoto($wrap);
						}

						const selectedValue = $('input[type="radio"]:checked', $wrap).val() || '';
						this.updateFormValue(fieldName, true, fieldLabel, 'checkbox', {
							selectedOption: selectedValue
						});

						// If this is a color question, update the selected color
						if (isColorQuestion) {
							this.updateSelectedColor();
							this.updateSummaryLayers();
						}
					} else {
						// If checkbox is unchecked, clear the radio selection
						$radioButtons.prop('checked', false);
						this.updateMultiChoicePhotoForFirst($wrap);
						this.removeFormValue(fieldName);

						// If this is a color question, update the selected color
						if (isColorQuestion) {
							this.updateSelectedColor();
							this.updateSummaryLayers();
						}
					}
				});
			});
		}

		// Method to update the photo in a multi-choice field
		updateMultiChoicePhoto($wrap) {
			const $photoContainer = $('[data-multi-choice-photo]', $wrap);
			const $selectedOption = $('input[type="radio"]:checked', $wrap).closest('[data-multi-choice-option]');

			if ($photoContainer.length && $selectedOption.length) {
				// Clone the image from the option and put it in the photo container
				const $optionPhoto = $('[data-multi-choice-option-photo]', $selectedOption);
				const $photoClone = $optionPhoto.children().clone();
				$photoContainer.empty().append($photoClone);
			} else {
				// If no option selected, show the first option's photo
				this.updateMultiChoicePhotoForFirst($wrap);
			}
		}

		// New method to set the photo to the first option when none is selected
		updateMultiChoicePhotoForFirst($wrap) {
			const $photoContainer = $('[data-multi-choice-photo]', $wrap);
			const $firstOption = $('[data-multi-choice-option]', $wrap).first();

			if ($photoContainer.length && $firstOption.length) {
				const $optionPhoto = $('[data-multi-choice-option-photo]', $firstOption);
				const $photoClone = $optionPhoto.children().clone();
				$photoContainer.empty().append($photoClone);
			}
		}

		renderOptionsSummary() {
			if (!this.$optionsSummary.length) return;

			let html = '';

			// Use the pre-calculated step groups
			for (const group of this.stepGroups) {
				// Skip empty groups
				if (!this.groupHasValues(group.steps)) continue;

				// Use the pre-generated title
				html += `<h4>${group.title}</h4><ul>`;

				// Add items from all steps in this group
				for (const stepIdx of group.steps) {
					const stepData = this.formValues[stepIdx] || {};

					// Add each option
					for (const fieldName in stepData) {
						const fieldData = stepData[fieldName];

						if (fieldData.type === 'checkbox' && fieldData.value === true) {
							// Checkbox format - check if it has a selected option (for multi-choice fields)
							if (fieldData.data && fieldData.data.selectedOption) {
								html += `<li>${fieldData.label} - ${fieldData.data.selectedOption}</li>`;
							} else {
								html += `<li>${fieldData.label}</li>`;
							}
						} else if (fieldData.type === 'range') {
							// Range format
							const suffix = fieldData.data && fieldData.data.suffix ? fieldData.data.suffix : '';
							html += `<li>${fieldData.label} - ${fieldData.value} ${suffix}</li>`;
						} else {
							// Generic format for other field types
							html += `<li>${fieldData.label}: ${fieldData.value}</li>`;
						}
					}
				}

				html += `</ul>`;
			}

			this.$optionsSummary.html(html || '<p>No options selected</p>');
		}


		initNoUiSlider() {

			if (!this.$sliders.length) return;

			this.$sliders.each((i, slider) => {
				const $slider = $(slider);
				const min = parseFloat($slider.data('min'));
				const max = parseFloat($slider.data('max'));
				const sliderId = $slider.attr('id');
				const inputField = document.getElementById(`${sliderId}-input`);

				// Check for intermediate values
				let intermediateValues = $slider.data('intermediate');
				let sliderConfig = {};

				if (intermediateValues) {
					// Parse comma-separated values into an array
					const valuesArray = intermediateValues.split(',').map(val => parseFloat(val.trim()));

					// Create full range array including min and max
					const rangeValues = [min, ...valuesArray, max];

					// Create a format object to map index positions to actual values
					const format = {
						to: function (value) {
							// Convert the slider index to the actual numeric value
							return rangeValues[Math.round(value)];
						},
						from: function (value) {
							// Find the index of the value in our array
							return rangeValues.indexOf(parseFloat(value));
						}
					};

					sliderConfig = {
						range: {
							'min': 0,
							'max': rangeValues.length - 1
						},
						step: 1,  // Step by index (1 unit at a time)
						// snap: true,
						connect: 'lower',
						format: format,
						pips: {
							mode: 'steps',
							format: format,
							density: 50,
							// stepped: true
						},
						start: [0]  // Start at the first index
					};
				} else {
					// Simple range slider with min and max
					sliderConfig = {
						range: {
							'min': min,
							'max': max
						},
						start: [min],
						step: (max - min) / 100, // Default step
						pips: {
							mode: 'positions',
							values: [0, 100], // Only show min and max
							density: 0
						}
					};
				}

				// Initialize noUiSlider
				const sliderInstance = noUiSlider.create(slider, sliderConfig);

				// Update value display and hidden input
				sliderInstance.on('update', function (values, handle) {
					let value;

					if (intermediateValues) {
						// For range sliders with intermediate values, the value is already formatted
						value = values[handle];
					} else {
						// For simple sliders, parse the value
						value = parseFloat(values[handle]);
					}

					inputField.value = value;

					// Trigger change event for form validation/submission
					$(inputField).trigger('change');
				});

				// Add click behavior to pips
				this.enablePipClicks(slider);
			});
		}

		// New method to enable pip clicks
		enablePipClicks(slider) {

			const pips = slider.querySelectorAll('.noUi-value');
			const hasFormat = slider.noUiSlider.options.format !== undefined;


			function clickOnPip() {
				let value = this.getAttribute('data-value');
				if (hasFormat) {
					const format = slider.noUiSlider.options.format;
					if (format && format.to) {
						value = format.to(value);
					}
				}
				slider.noUiSlider.set(value);
			}

			for (let i = 0; i < pips.length; i++) {
				pips[i].style.cursor = 'pointer';
				pips[i].addEventListener('click', clickOnPip);
			}

			// Get all markers (the small lines/dots)
			const markers = slider.querySelectorAll('.noUi-marker');

			function clickOnMarker() {
				// Find the closest value pip to this marker
				const closestPip = this.closest('.noUi-marker').nextElementSibling;
				if (closestPip && closestPip.classList.contains('noUi-value')) {
					let value = closestPip.getAttribute('data-value');
					if (hasFormat) {
						const format = slider.noUiSlider.options.format;
						if (format && format.to) {
							value = format.to(value);
						}
					}
					slider.noUiSlider.set(value);
				} else {
					// If no pip found, try to estimate position
					const markerStyle = window.getComputedStyle(this);
					const leftPos = parseFloat(markerStyle.left) / 100;
					const min = slider.noUiSlider.options.range.min;
					const max = slider.noUiSlider.options.range.max;
					const value = min + leftPos * (max - min);
					slider.noUiSlider.set(value);
				}
			}

			// Add click events to markers
			for (let i = 0; i < markers.length; i++) {
				markers[i].style.cursor = 'pointer';
				markers[i].addEventListener('click', clickOnMarker);
			}

		}


		initImageLayers() {
			// Find the color question (if any)
			this.findColorQuestion();

			// Find all fields with layers
			this.collectLayerElements();

			// Initialize the layers in the summary
			if (this.$summaryLayersContainer.length > 0) {
				this.updateSummaryLayers();
			}
		}

		// Find the color question in the configurator
		findColorQuestion() {
			const $colorQuestion = $('[data-is-color-question="1"]', this.$wrap);

			if ($colorQuestion.length > 0) {
				// Get the question information
				const $parentField = $colorQuestion.find('input[data-field-type="single-choice"]');
				const fieldName = $parentField.attr('name');

				if (fieldName) {
					const stepMatch = fieldName.match(/step\[(\d+)\]\[(\d+)\]/);
					if (stepMatch) {
						this.colorQuestion = {
							stepIdx: stepMatch[1],
							fieldIdx: stepMatch[2],
							element: $colorQuestion[0],
							options: []
						};

						// Get all color options
						$colorQuestion.find('[data-is-color-option="1"]').each((i, option) => {
							const $option = $(option);
							this.colorQuestion.options.push({
								value: $option.val(),
								index: $option.data('option-index')
							});
						});
					}
				}
			}
		}

		// Collect all elements with layers
		collectLayerElements() {
			// Look for yes/no questions with layers
			$('input[data-has-layers="1"]', this.$wrap).each((i, input) => {
				const $input = $(input);
				const $parent = $input.closest('.c-configurator__yes-no-wrap');
				const $layersContainer = $('[data-summary-layers]', $parent);

				if ($layersContainer.length > 0) {
					const stepIdx = $layersContainer.data('step-idx');
					const fieldIdx = $layersContainer.data('field-idx');
					const key = `${stepIdx}_${fieldIdx}`;

					this.layerElements[key] = {
						type: 'yes_no',
						element: $layersContainer[0],
						stepIdx: stepIdx,
						fieldIdx: fieldIdx,
						layers: []
					};

					// Collect all layers
					$('[data-layer-index]', $layersContainer).each((j, layer) => {
						const $layer = $(layer);
						const layerIdx = $layer.data('layer-index');
						const manualZIndex = $layer.data('z-index');

						let zIndex;
						if (manualZIndex !== undefined && manualZIndex !== '') {
							zIndex = parseInt(manualZIndex) + parseInt(layerIdx);
						} else {
							zIndex = 100 * parseInt(stepIdx) + 10 * parseInt(fieldIdx) + parseInt(layerIdx);
						}

						this.layerElements[key].layers.push({
							index: layerIdx,
							element: layer,
							zIndex: zIndex
						});
					});
				}
			});

			// Look for single choice questions with layers
			$('[data-summary-option-layers]', this.$wrap).each((i, container) => {
				const $container = $(container);
				const stepIdx = $container.data('step-idx');
				const fieldIdx = $container.data('field-idx');
				const optionIdx = $container.data('option-idx');
				const key = `${stepIdx}_${fieldIdx}_${optionIdx}`;

				this.layerElements[key] = {
					type: 'single_choice',
					element: container,
					stepIdx: stepIdx,
					fieldIdx: fieldIdx,
					optionIdx: optionIdx,
					layers: []
				};

				// Collect all layers
				$('[data-layer-index]', $container).each((j, layer) => {
					const $layer = $(layer);
					const layerIdx = $layer.data('layer-index');
					const manualZIndex = $layer.data('z-index');

					let zIndex;

					if (manualZIndex !== undefined && manualZIndex !== '') {
						// Use manual z-index if set
						zIndex = parseInt(manualZIndex) + parseInt(layerIdx) + parseInt(optionIdx);
					} else {
						// Calculate structured z-index as fallback: 100*stepIdx + 10*fieldIdx + layerIdx
						// For single choice options, we'll add the optionIdx in the ones place
						zIndex = 100 * parseInt(stepIdx) + 10 * parseInt(fieldIdx) + parseInt(layerIdx) + parseInt(optionIdx);
					}
					this.layerElements[key].layers.push({
						index: layerIdx,
						element: layer,
						zIndex: zIndex
					});
				});
			});
		}

		// Update the summary layers based on form selections
		updateSummaryLayers() {
			// Clear existing layers
			this.$summaryLayersContainer.empty();

			// Get the currently selected color (if any)
			this.updateSelectedColor();

			// Add layers for selected options
			for (const key in this.formValues) {
				const stepData = this.formValues[key];

				for (const fieldName in stepData) {
					const fieldData = stepData[fieldName];

					// Extract step and field index
					const stepMatch = fieldName.match(/step\[(\d+)\]\[(\d+)\]/);
					if (!stepMatch) continue;

					const stepIdx = stepMatch[1];
					const fieldIdx = stepMatch[2];
					const lookupKey = `${stepIdx}_${fieldIdx}`;

					// Handle yes/no questions
					if (fieldData.type === 'checkbox' && fieldData.value === true) {
						if (this.layerElements[lookupKey] && this.layerElements[lookupKey].type === 'yes_no') {
							this.addLayersToSummary(this.layerElements[lookupKey], fieldData);
						}
					}

					// Handle single choice questions
					if (fieldData.type === 'checkbox' && fieldData.data && fieldData.data.selectedOption) {
						const optionMatch = fieldName.match(/step\[(\d+)\]\[(\d+)\]/);
						if (!optionMatch) continue;

						// Find the selected option index
						const $parent = $(`input[name="${fieldName}"]`).closest('.c-configurator__multi-choice-wrap');
						const $selectedOption = $(`input[name="${fieldName}[option]"][value="${fieldData.data.selectedOption}"]`, $parent);

						if ($selectedOption.length > 0) {
							const optionIdx = $selectedOption.data('option-index');
							const optionKey = `${stepIdx}_${fieldIdx}_${optionIdx}`;

							if (this.layerElements[optionKey]) {
								this.addLayersToSummary(this.layerElements[optionKey], fieldData);
							}
						}
					}
				}
			}
		}

		// Add layers from an element to the summary
		addLayersToSummary(layerElement, fieldData) {
			let layerFound = false;

			// First try to match the layer index with the selected color index (if a color is selected)
			if (this.selectedColor !== null) {
				const colorIndex = this.selectedColor.index;

				// Try to find a layer with matching color index
				for (const layer of layerElement.layers) {
					if (layer.index == colorIndex) {
						// Clone the layer and add it to the summary
						const $clone = $(layer.element).clone();
						$clone.css({
							'position': 'absolute',
							'top': 0,
							'left': 0,
							'width': '100%',
							'height': '100%',
							'z-index': layer.zIndex
						});
						this.$summaryLayersContainer.append($clone);
						layerFound = true;
						break;
					}
				}
			}

			// If no matching layer found (or no color selected), use the first layer (index 0)
			if (!layerFound) {
				// Find the first layer (index 0)
				const firstLayer = layerElement.layers.find(layer => layer.index == 0);

				if (firstLayer) {
					// Clone the layer and add it to the summary
					const $clone = $(firstLayer.element).clone();
					$clone.css({
						'position': 'absolute',
						'top': 0,
						'left': 0,
						'width': '100%',
						'height': '100%',
						'z-index': firstLayer.zIndex
					});
					this.$summaryLayersContainer.append($clone);
				}
			}
		}

		// Update the selected color information
		updateSelectedColor() {
			this.selectedColor = null;

			if (!this.colorQuestion) return;

			// Build the field name from the color question data
			const fieldName = `step[${this.colorQuestion.stepIdx}][${this.colorQuestion.fieldIdx}]`;

			// Check if this field is in the form values and is checked
			if (this.formValues[this.colorQuestion.stepIdx] &&
				this.formValues[this.colorQuestion.stepIdx][fieldName] &&
				this.formValues[this.colorQuestion.stepIdx][fieldName].value === true) {

				const fieldData = this.formValues[this.colorQuestion.stepIdx][fieldName];

				// If it has a selected option
				if (fieldData.data && fieldData.data.selectedOption) {
					// Find the corresponding option in our color question
					const optionValue = fieldData.data.selectedOption;

					// Find the option index
					const $option = $(`input[name="${fieldName}[option]"][value="${optionValue}"]`, this.$wrap);
					if ($option.length > 0) {
						const optionIndex = $option.data('option-index');

						this.selectedColor = {
							value: optionValue,
							index: parseInt(optionIndex)
						};
					}
				}
			}
		}

	}

})(jQuery);

export default configuratorInit;